export type TemplateEmailType = "occasional" | "reminder" | "referral" | "transactional";

export interface EmailTemplate {
  email_template_id: string;
  title: string;
  subject: string;
  body: string;
  occasion_id: string;
  organization_id: string;
  user_id: string | null;
  type: EmailTemplateType;
  category?: TemplateCategory;
  email_type?: TemplateEmailType;
  template_key?: string | null;
  template_type?: TemplateType;
  text_message_body?: string;
  is_active: boolean;
  is_delete: boolean;
  added_on: string;
  updated_at: string;
  created_by?: string;
  template_category?: string;
}


export enum EmailTemplateType {
  SYSTEM = "system",
  USER = "user",
  EMAILER = "emailer"
}

export enum TemplateCategory {
  GIFT = "gift",
  MAILER = "mailer",
}

export enum TemplateType {
  TEXTMESSAGE = "text_message",
  EMAIL = "email",
  TEXTMESSAGE_AND_EMAIL = "text_message_and_email"
}
